class SearchResultsStateLayer {
  constructor() {

    this.eventBus = window.theme.searchResults.eventBus;

    this.state = {
      activeTerm: this.activeTerm,
      activeFacets: [],
      activeSort: { field: 'score', order: 'desc' },
      facets: [],
      lastSelectedDetail: null,
      pagination: {},
      products: [],
      sort: [
        { field: 'score', order: 'desc', label: 'Relevance', selected: true },
        { field: 'price', order: 'asc', label: 'Price: Low to High', selected: false },
        { field: 'price', order: 'desc', label: 'Price: High to Low', selected: false },
        { field: 'name', order: 'asc', label: 'Name: A to Z', selected: false },
        { field: 'name', order: 'desc', label: 'Name: Z to A', selected: false },
        { field: 'datePublished', order: 'desc', label: 'Newest', selected: false },
        { field: 'datePublished', order: 'asc', label: 'Oldest', selected: false }
      ],
    };

    // Subscribe to events
    this.subscribeToEvents();
    this.initializeActiveFacetsFromSearchParams();
  }

  subscribeToEvents() {
    // Subscribe to product updates
    this.eventBus.subscribe('searchResults:api:results:fetched', (response) => {
      const hits = response.products.hits;

      const pagination = {
        total: response.products.total,
        size: response.products.size,
        from: response.products.from,
        totalPages: Math.ceil(response.products.total / response.products.size),
        currentPage: Math.ceil((response.products.from + 1) / response.products.size)
      };

      this.state.pagination = pagination;
      this.products = hits;
    });

    // Subscribe to facet updates
    this.eventBus.subscribe('searchResults:api:facets:fetched', (facets) => {
      this.facets = facets;
    });

    // Subscribe to UI facet changes
    this.eventBus.subscribe('searchResults:ui:facets:changed', ({ field, value }) => {
      if (field === 'sort') {
        const sortValue = value[0].split('~');
        this.activeSort = {
          field: sortValue[0],
          order: sortValue[1]
        };

        this.state.lastSelectedDetail = 'sort';
        this.updateSearchParams();
        return;
      } else {
        this.activeFacets = [
          ...this.state.activeFacets.filter(facet => facet.field !== field),
          { field, value }
        ];
        this.state.lastSelectedDetail = field;
        this.updateSearchParams();
      }
    });

    // Subscribe to facet removal
    this.eventBus.subscribe('searchResults:ui:facet:removed', ({ field, value }) => {
      const fieldToRemove = this.state.activeFacets.find(facet => facet.field === field);
      if (fieldToRemove) {
        const valueIndex = fieldToRemove.value.indexOf(value);
        fieldToRemove.value.splice(valueIndex, 1);
      }
      // Build and append search parameters
      this.updateSearchParams();
    });

    this.eventBus.subscribe('searchResults:state:activeSort:updated', (activeSort) => {
      this.state.sort.forEach(sort => {
        if (sort.field === activeSort.field && sort.order === activeSort.order) {
          sort.selected = true;
        } else {
          sort.selected = false;
        }
      });
    });



    this.eventBus.subscribe('searchResults:ui:pagination:changed', (cursor) => {
      this.paginationCursor = cursor.current;
      this.updateSearchParams(cursor.direction);
    });

    this.eventBus.subscribe('searchResults:ui:facets:clearAll', () => {
      this.activeFacets = [];
      this.activeSort = { field: 'score', order: 'desc' };
      this.updateSearchParams();
    });
  }

  initializeActiveFacetsFromSearchParams() {
    const searchParams = new URLSearchParams(window.location.search);
    const activeFacets = [];

    searchParams.forEach((value, key) => {
      const values = value.includes(',') ? value.split(',') : [value];

      switch (key) {
        case 'sort':
          const [field, order] = values[0].split('~');
          this.activeSort = { field, order };
          break;
        case 'page':
          const currentPage = parseInt(value, 10);
          this.state.pagination.currentPage = currentPage;
          this.state.pagination.from = this.calculateFrom(currentPage, 40);
          break;
        case 'q':
          this.state.activeTerm = value;
          break;
        default:
          activeFacets.push({ field: key, value: values });
      }
    });

    this.activeFacets = activeFacets;
  }


  calculateFrom(currentPage, pageSize) {
    return (currentPage - 1) * pageSize;
  }


  updateSearchParams(paginationDirection) {
    clearTimeout(this.updateSearchParamsTimeout);
    this.updateSearchParamsTimeout = setTimeout(() => {
      const searchParams = new URLSearchParams();
      let bypassPageParam = false;

      if (this.state.activeTerm) {
        searchParams.set('q', this.state.activeTerm);
      }

      this.state.activeFacets.forEach(facet => {
        if (facet.value.length > 0) {
          searchParams.set(facet.field, facet.value.join(','));
        }
      });

      if (this.state.activeSort) {
        searchParams.set('sort', `${this.state.activeSort.field}~${this.state.activeSort.order}`);
      }

      if(!bypassPageParam) {
        if (this.state.pagination.currentPage <= this.state.pagination.totalPages) {
          console.log(paginationDirection)

          if(paginationDirection === 'next') {
            this.state.pagination.currentPage += 1;
          }

          if(paginationDirection === 'previous') {
            this.state.pagination.currentPage -= 1;
          }

          searchParams.set('page', this.state.pagination.currentPage);
        }
      }

      const newUrl = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.replaceState({}, '', newUrl);

      this.eventBus.publish('searchResults:api:fetch:products');
    }, 300);
  }

  set products(products) {
  this.state.products = products;
    this.eventBus.publish('searchResults:state:products:updated', products);
  }

  set facets(facets) {
    this.state.facets = facets;
    this.eventBus.publish('searchResults:state:facets:updated', facets);
  }

  set activeFacets(activeFacets) {
    this.state.activeFacets = activeFacets;
  }

  set activeSort(activeSort) {
    this.state.activeSort = activeSort;
    this.eventBus.publish('searchResults:state:activeSort:updated', activeSort);
  }

  get activeTerm() {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get('q') || '';
  }

  set paginationCursor(cursor) {
    this.state.pagination.from = Number(cursor);
  }
}

window.theme.searchResults.stateLayer = new SearchResultsStateLayer();
